import { Cover } from 'types/cover';
import { InterestedPartyUI, PolicyBuilderMode } from 'types/policy';

import { selectPolicyData } from '../selectors/selectPolicyData';
import { useAppSelector } from './useSelectors';

interface PolicyDataBuilderOptions {
  /** @todo infer issueDocument, includeAccessToken and makePayment from the new "mode" attribute */
  mode?: PolicyBuilderMode;
  covers?: Cover[];
  interestedParties?: InterestedPartyUI[];
  issueDocument?: boolean;
  includeAccessToken?: boolean;
  makePayment?: boolean;
}

/**
 * @description
 * Builds policy data for the backend post call.
 */
export const usePolicyDataBuilder = (options?: PolicyDataBuilderOptions) => {
  const policyData = useAppSelector((state) => selectPolicyData(state, options));

  const getPolicyData = () => policyData;
  return { getPolicyData };
};
